import React, { Component } from 'react';

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SigPadTransparent from "./extensions/SigPadTransparent";
import Button from "@material-ui/core/Button";
import { setTitle } from "../actions/AppActions";
import TextField from '@material-ui/core/TextField';
import {
  SelectedAppSelector,
  //SelectedAppAttachmentsSelector,
  SelectedCompanyAttachmentSelector
} from '../selectors/SelectedAppointmentSelector';
import {
  SaveSignatures,
  SelectAppointmentByID,
  SaveData
} from "../actions/TaskActions";
import {
  SuccessIcon,
} from '../bundles/IconsBundle';
import { Text } from '../extensions/LangaugeContainer';
import { Checkbox } from '@material-ui/core';
import MessageBox from './dialogs/MessageBox';
const styles2 = {
  card: {
    margin: "20px",
    border: "1px solid #999"
  }
};

class SignAuftragMultiple extends Component {
  state = {
    kundeSignatureCheckbox: false,
    dialogOpen:false,
    DruckbuchstabenKunde:"",
  };
  sigPadKunde = {};
  sigPadBerater = {};
  beraterEmpty=true;
  kundeEmpty=true;

  componentDidMount() {
    this.props.setTitle(<Text tid="sign"/>);
    this.props.SelectAppointmentByID(this.props.match.params.id);
    console.log("mounted");
  }

  dialogClose = () =>{
    this.setState({dialogOpen: false});
  }

  handleClearKunde = () => {
    this.sigPadKunde.clear();
    this.kundeEmpty = true;

    this.setState({
      kundeSignatureCheckbox: false
    })
  };

  handleClearBerater = () => {
    this.sigPadBerater.clear();
    this.beraterEmpty = true;
  };

  UpdateBeraterSignature = () => {
    if (this.sigPadBerater)
      this.sigPadBerater.fromDataURLTransparent(
        this.props.app.SignatureBerater,
        { width: 500, height: 200 }
      );
  };

  handleCheckbox = (e) =>{
    if(this.state.kundeSignatureCheckbox === true)
    {
       this.setState({kundeSignatureCheckbox:false});
       this.handleClearKunde();
    }
    else
    {
      this.UpdateKundeSignature(e,true);
    }
  }

  UpdateKundeSignature = (event, drawText) => {
    if(drawText){
      this.kundeEmpty = false;
      let canvas = this.sigPadKunde._canvas.getContext("2d");
      canvas.font = "2em Arial";
      canvas.fillText(event.currentTarget.previousElementSibling.innerText, 20, 120);

      this.setState({
        kundeSignatureCheckbox: true
      })
      return;
    }
    if (this.sigPadKunde)
      this.sigPadKunde.fromDataURLTransparent(
        this.props.app.SignatureKunde,
        { width: 500, height: 200 }
      );
  };

  checkIfEmptyBerater = () =>{
    this.beraterEmpty = false;
  }
  checkIfKundeEmpty = () =>{
    this.kundeEmpty = false;
  }

  handleSave = () => {

    if(this.beraterEmpty || this.kundeEmpty)
    {
      this.setState({dialogOpen: true});
    } else {
      const beraterSignature = this.sigPadBerater.toDataURLTransparent(
        "image/png"
      );
      const kundeSignature = this.sigPadKunde.toDataURLTransparent(
        "image/png"
      );
  
      let xPos, yPos, pdfName, UniqueId;
      if (Array.isArray(this.props.files)) {
        this.props.files.forEach(element => {
          if (element.hasOwnProperty("SignaturePosition")) {
            xPos = element.SignaturePosition.X;
            yPos = element.SignaturePosition.Y;
            pdfName = element.FileName;
            UniqueId = element.id;
  
            const value = {
              SignatureBerater: beraterSignature,
              SignatureKunde: kundeSignature,
              x: xPos,
              y: yPos,
              PdfName: pdfName,
              UniqueID: UniqueId
            };
    
            this.props.SaveSignatures(value, value);
          }else{
            return;
          }      
        });
      }else{
        alert("Error - signatures not saved !");
      }
      this.props.history.goBack();
    }
  };

  render() {
    //console.log("Signature props: ", this.props);
    return (
      <div style={{ marginTop: "80px" }}>
        <MessageBox
          Title={<Text tid="signatureEmpty"/>}
          CancelText={<Text tid="cancel"/>}
          AcceptText={""}
          handleClose={this.dialogClose}
          handleAccept={this.dialogClose}
          open={this.state.dialogOpen} />
        <Paper elevation={1} style={styles2.card}>
          <Typography variant="h5" component="h3">
            <FormControlLabel
              labelPlacement="bottom"
              control={
                <SigPadTransparent
                  ref={ref => {
                    this.sigPadKunde = ref;
                    this.UpdateKundeSignature();
                  }}
                  onBegin={this.checkIfKundeEmpty}
                  onEnd={this.saveSignature}
                  backgroundColor="rgba(200,200,200,1)"
                  penColor="blue"
                  canvasProps={{
                    width: 500,
                    height: 200,
                    className: "sigCanvas"
                  }}
                />
              }
              label={<Text tid="customerSignature"/>}
            />
          </Typography>
          <div>
            <TextField
                                  label={"Druckbuchstaben"}
                                  name="DruckbuchstabenKunde"
                                  onBlur={(e) => this.props.SaveData(this.props.app, { DruckbuchstabenKunde: e.target.value })}
                                  margin="normal"
                                  style={{ marginTop: "0px", width:400 }}
                                  variant="outlined"
                                  inputProps={{ maxLength: 149 }}
                              />
          {/* <Button
            color="primary"
            variant="contained"
            onClick={(e) => this.UpdateKundeSignature(e, true)}
            style={{marginBottom:"5px", marginRight: "5px"}}
          >
            <Text tid="clientNotAtHome"/>
          </Button> */}
          </div>
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleClearKunde}
            style={{ marginBottom: "5px" }}
          >
            <Text tid="delete"/>
          </Button>
          <label style={{marginLeft: "0.4rem"}}><Text tid="clientNotAtHome"/></label>
          <Checkbox
            checked={this.state.kundeSignatureCheckbox}
            color="primary"
            variant="contained"
            onClick={(e) => this.handleCheckbox(e)}
            style={{
              marginBottom: "0.1rem",
              position: "relative",
              right: "0.4rem"
            }}
          >
          </Checkbox>
          {/* <Button
            color="primary"
            variant="contained"
            onClick={this.handleSave}
          >
            Save signature
          </Button> */}
        </Paper>

        <Paper elevation={1} style={styles2.card}>
          <Typography variant="h5" component="h3">
            <FormControlLabel
              labelPlacement="bottom"
              control={
                <SigPadTransparent
                  ref={ref => {
                    this.sigPadBerater = ref;
                    this.UpdateBeraterSignature();
                  }}
                  onBegin={this.checkIfEmptyBerater}
                  onEnd={this.saveSignature}
                  backgroundColor="rgba(200,200,200,1)"
                  penColor="blue"
                  canvasProps={{
                    width: 500,
                    height: 200,
                    className: "sigCanvas"
                  }}
                />
              }
              label={<Text tid="driverSignature"/>}
            />
          </Typography>
          <div>
            <TextField
                                  label={"Druckbuchstaben"}
                                  name="DruckbuchstabenFahrer"
                                  onBlur={(e) => this.props.SaveData(this.props.app, { DruckbuchstabenFahrer: e.target.value })}
                                  margin="normal"
                                  style={{ marginTop: "0px", width:400 }}
                                  variant="outlined"
                                  inputProps={{ maxLength: 149 }}
                              />
          {/* <Button
            color="primary"
            variant="contained"
            onClick={(e) => this.UpdateKundeSignature(e, true)}
            style={{marginBottom:"5px", marginRight: "5px"}}
          >
            <Text tid="clientNotAtHome"/>
          </Button> */}
          </div>
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleClearBerater}
          >
            <Text tid="delete"/>
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => this.handleSave()}
            style={{ margin: "5px" }}
          >
            <SuccessIcon style={{ marginRight: "5px", paddingLeft: "0px", color: "#FFFFFF", }} />
            {/* Speichern sie Dokumente für alle heutigen auftrag von dieser Firma */}
            <Text tid="saveDocumentForAll"/>
          </Button>
        </Paper>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  app: SelectedAppSelector(state),
  files: SelectedCompanyAttachmentSelector(state)
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      setTitle,
      SaveSignatures,
      SaveData,
      SelectAppointmentByID
    }
  )(SignAuftragMultiple)
);